// extracted by mini-css-extract-plugin
export var btnMenu = "BtnMenu_btnMenu__NJTR3";
export var rotate = "BtnMenu_rotate__ayGMN";
export var dotty = "BtnMenu_dotty__klcm8";